<template>
  <main class="page-shell">
    <div class="toolbar">
      <el-input v-model="keyword" size="small" clearable placeholder="搜索用户名/名称/邮箱" class="search-input"
                @keyup.enter.native="load" @clear="load" />
      <div class="toolbar-spacer"></div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate">新增用户</el-button>
    </div>

    <div v-loading="loading" class="user-card-grid">
      <div v-for="u in list" :key="u.id" class="user-card">
        <div class="user-card-top">
          <div class="user-card-avatar">{{ avatarChar(u.name || u.username) }}</div>
          <div class="user-card-main">
            <div class="user-card-name">{{ u.name || u.username }}</div>
            <div class="user-card-sub">{{ u.username }}</div>
          </div>
          <el-tag :type="u.status === 'active' ? 'success' : 'danger'" size="small">
            {{ u.status === 'active' ? '可用' : '停用' }}
          </el-tag>
        </div>

        <div class="user-card-stats">
          <div class="user-card-stat">
            <div class="user-card-stat-label">当前余额</div>
            <div class="user-card-stat-value" :style="{ color: Number(u.balance) > 0 ? 'var(--green)' : 'var(--red)' }">
              {{ formatMoney(u.balance) }} 元
            </div>
          </div>
          <div class="user-card-stat">
            <div class="user-card-stat-label">创建时间</div>
            <div class="user-card-stat-value user-card-stat-sub">{{ formatTime(u.createdAt) }}</div>
          </div>
        </div>

        <div class="user-card-actions">
          <el-button size="small" type="text" style="color: var(--cyan)" @click="$router.push('/admin/users/' + u.id)">详情 / 计费</el-button>
          <el-button size="small" type="text" :class="u.status === 'active' ? 'btn-danger' : 'btn-enable'" @click="toggleStatus(u)">
            {{ u.status === 'active' ? '停用' : '启用' }}
          </el-button>
        </div>
      </div>
    </div>

    <el-empty v-if="!loading && list.length === 0" description="暂无用户" :image-size="80" />

    <el-pagination class="pagination-bar" layout="total, prev, pager, next" :total="total"
                   :page-size="size" :current-page.sync="page" @current-change="load" small />

    <!-- 新增用户 / 开通流量包 -->
    <el-dialog title="新增用户 / 开通流量包" :visible.sync="showCreate" width="420px">
      <el-form ref="createForm" :model="createForm" size="small" label-width="90px">
        <el-form-item label="用户名" required>
          <el-input v-model="createForm.username" placeholder="用于登录" />
        </el-form-item>
        <el-form-item label="密码" required>
          <el-input v-model="createForm.password" placeholder="至少 6 位" show-password />
        </el-form-item>
        <el-form-item label="初始金额">
          <el-input-number v-model="createForm.balance" :min="0" :precision="2" :controls="false" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="showCreate = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submitCreate">创建</el-button>
      </div>
    </el-dialog>
  </main>
</template>

<script>
import { formatMoney, formatTime } from '@/utils/format'

export default {
  name: 'AdminUsers',
  data() {
    return {
      keyword: '',
      list: [],
      total: 0,
      page: 1,
      size: 12,
      loading: false,
      showCreate: false,
      saving: false,
      createForm: { username: '', password: '', balance: 0 }
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatMoney,
    formatTime,
    avatarChar(name) {
      const s = (name || '').trim()
      return s ? s.substring(0, 1).toUpperCase() : 'U'
    },
    async load() {
      this.loading = true
      try {
        const res = await this.$http.get('/admin/users', {
          params: { keyword: this.keyword, page: this.page, size: this.size }
        })
        if (res.code === 200) {
          this.list = res.data.list
          this.total = res.data.total
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.createForm = { username: '', password: '', balance: 0 }
      this.showCreate = true
    },
    async submitCreate() {
      if (!this.createForm.username || !this.createForm.password) {
        this.$message.warning('用户名和密码必填')
        return
      }
      this.saving = true
      try {
        const res = await this.$http.post('/admin/users', this.createForm)
        if (res.code === 200) {
          this.$message.success('创建成功')
          this.showCreate = false
          this.load()
        }
      } catch (e) {
      } finally {
        this.saving = false
      }
    },
    async toggleStatus(row) {
      const target = row.status === 'active' ? 'inactive' : 'active'
      try {
        const res = await this.$http.put(`/admin/users/${row.id}/status`, null, { params: { status: target } })
        if (res.code === 200) {
          this.$message.success(target === 'active' ? '已启用' : '已停用')
          this.load()
        }
      } catch (e) {}
    }
  }
}
</script>

<style scoped>
.search-input {
  width: 240px;
}

.user-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.user-card {
  padding: 16px 18px;
  border-radius: var(--radius);
  background: linear-gradient(180deg, rgba(27, 39, 58, 0.92), rgba(20, 30, 46, 0.88));
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s;
}

.user-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(50, 200, 245, 0.3);
}

.user-card-top {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-card-avatar {
  width: 44px;
  height: 44px;
  flex: none;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--blue), var(--cyan));
  color: #fff;
  font-size: 17px;
  font-weight: 900;
  box-shadow: 0 8px 20px rgba(50, 150, 245, 0.28);
}

.user-card-main {
  min-width: 0;
  flex: 1;
}

.user-card-name {
  font-size: 15px;
  font-weight: 800;
  color: var(--text);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-card-sub {
  margin-top: 3px;
  font-size: 12px;
  color: var(--muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-card-sub .dot {
  margin: 0 5px;
  color: var(--muted-2);
}

.user-card-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin: 14px 0 12px;
}

.user-card-stat {
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid var(--line-soft);
  border-radius: 8px;
  padding: 8px 12px;
}

.user-card-stat-label {
  font-size: 11px;
  color: var(--muted-2);
  margin-bottom: 3px;
  letter-spacing: 0.02em;
}

.user-card-stat-value {
  font-size: 16px;
  font-weight: 800;
  color: var(--cyan);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-card-stat-sub {
  font-size: 12px;
  color: var(--muted);
  font-weight: 600;
}

.user-card-actions {
  display: flex;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--line-soft);
}

.user-card-actions .el-button + .el-button {
  margin-left: 0;
}

.btn-enable {
  color: var(--cyan);
}

.btn-danger {
  color: #ff93a4;
}

.btn-danger:hover {
  color: #ffb6c1;
}

@media (max-width: 640px) {
  .user-card-grid {
    grid-template-columns: 1fr;
  }
}
</style>